import { createActions } from 'redux-actions';
export const UPDATE = 'UPDATE';

export const options = {
  prefix: 'FILTERS/SM_WORKLIST'
};

export const { update } = createActions(UPDATE, options);
